import { useMutation, useQueryClient } from '@tanstack/react-query';

import { fetcher } from '../../http/Fetcher';

interface UploadMemberImageResponse {
    url: string;
    message?: string;
}

export const useUploadMemberImage = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({
            userId,
            file,
        }: {
            userId: string;
            file: File;
        }) => {
            const formData = new FormData();
            formData.append('image', file);

            return await fetcher<UploadMemberImageResponse>({
                endpoint: `/api/admin/users/${userId}/image`,
                method: 'PATCH',
                body: formData,
                contentType: null,
            });
        },
        onSuccess: (_data, variables) => {
            void queryClient.invalidateQueries({
                queryKey: ['memberImage', variables.userId],
            });
        },
    });
};
